"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactRedux = require("react-redux");

var _text = require("@mmc/text");

var _commonCta = require("@mmc/common-cta");

var _commonI18n = require("@mmc/common-i18n");

var _modelSelector = require("./model-selector.prop-types");

var _modelSelector2 = _interopRequireDefault(require("./model-selector.css"));

var ModelSelector = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(ModelSelector, _React$PureComponent);

  ModelSelector.resourceType = function resourceType() {
    return 'ModelSelector_1_0_0';
  };

  function ModelSelector(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      selectedIdx: props.defaultModelIndex
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = ModelSelector.prototype;

  _proto.handleChange = function handleChange(event) {
    var selectedIdx = +event.target.value;
    var _this$props = this.props,
        onChange = _this$props.onChange,
        vehicles = _this$props.data.vehicles;
    var selectedModel = vehicles[selectedIdx];
    this.setState({
      selectedIdx: selectedIdx
    });
    onChange(selectedIdx, selectedModel);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        theme = _this$props2.theme,
        _this$props2$data = _this$props2.data,
        vehicleName = _this$props2$data.vehicleName,
        paymentCalculatorLabel = _this$props2$data.paymentCalculatorLabel,
        msrpLabel = _this$props2$data.msrpLabel,
        msrpDisclaimerNo = _this$props2$data.msrpDisclaimerNo,
        ctaText = _this$props2$data.ctaText,
        ctaUrl = _this$props2$data.ctaUrl,
        vehicles = _this$props2$data.vehicles,
        hideKeyFeatures = _this$props2$data.hideKeyFeatures,
        addPriceDisclaimer = _this$props2.addPriceDisclaimer,
        priceDisclaimerId = _this$props2.priceDisclaimerId,
        disclaimerData = _this$props2.disclaimerData,
        config = _this$props2.config;
    var selectedIdx = this.state.selectedIdx;
    var vehicle = vehicles[selectedIdx];

    if (!vehicle) {
      return null;
    }

    var msrpValue = vehicle.msrpValue,
        keyFeatures = vehicle.keyFeatures,
        imageAltText = vehicle.imageAltText,
        imagePath = vehicle.imagePath;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(_modelSelector2["default"].modelSelector, className)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _modelSelector2["default"].infoGroup
    }, paymentCalculatorLabel && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      tag: "p",
      text: paymentCalculatorLabel,
      className: _modelSelector2["default"].title,
      disclaimerData: disclaimerData
    }), vehicleName && /*#__PURE__*/_react["default"].createElement("p", {
      className: _modelSelector2["default"].vehicleName
    }, vehicleName), vehicles && /*#__PURE__*/_react["default"].createElement("select", {
      className: (0, _clsx["default"])(_modelSelector2["default"].selectModel, theme.customSelect),
      value: selectedIdx,
      onChange: this.handleChange,
      "aria-label": ctaText
    }, vehicles.map(function (_ref, index) {
      var modelName = _ref.modelName;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react["default"].createElement("option", {
          key: "" + index + modelName,
          value: index
        }, modelName)
      );
    })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _modelSelector2["default"].msrpAndCtaGroup
    }, msrpLabel && msrpValue && /*#__PURE__*/_react["default"].createElement("p", {
      className: _modelSelector2["default"].msrp
    }, msrpLabel, ' ', /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        value: msrpValue,
        currency: config.currencyFormat,
        locale: config.localeCode
      }
    }), msrpDisclaimerNo && /*#__PURE__*/_react["default"].createElement("sup", null, msrpDisclaimerNo), addPriceDisclaimer && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      tag: "span",
      text: " #" + priceDisclaimerId + "#",
      disclaimerData: disclaimerData,
      className: _modelSelector2["default"].msrpDisclaimer
    })), ctaText && /*#__PURE__*/_react["default"].createElement("span", {
      className: _modelSelector2["default"].ctaLinkDesktop
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      data: {
        label: ctaText,
        url: ctaUrl,
        priority: 'trivial'
      }
    })))), !hideKeyFeatures && Array.isArray(keyFeatures) && keyFeatures.length > 0 && /*#__PURE__*/_react["default"].createElement("p", {
      className: _modelSelector2["default"].description
    }, keyFeatures.map(function (item, index) {
      return (// eslint-disable-next-line react/no-array-index-key
        item && /*#__PURE__*/_react["default"].createElement(_text.Text, {
          tag: "span",
          key: index,
          text: item,
          disclaimerData: disclaimerData
        })
      );
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _modelSelector2["default"].imgAndCtaGroup
    }, ctaText && /*#__PURE__*/_react["default"].createElement("div", {
      className: _modelSelector2["default"].ctaLink
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      data: {
        label: ctaText,
        url: ctaUrl,
        priority: 'trivial'
      }
    })), imagePath && /*#__PURE__*/_react["default"].createElement("div", {
      className: _modelSelector2["default"].imageContainer
    }, /*#__PURE__*/_react["default"].createElement("img", {
      alt: imageAltText,
      src: imagePath
    }))));
  };

  return ModelSelector;
}(_react["default"].PureComponent);

ModelSelector.displayName = 'ModelSelector';
ModelSelector.defaultProps = {
  onChange: function onChange() {
    return undefined;
  },
  defaultModelIndex: 0
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    config: props.config || state.Config
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(ModelSelector);

exports["default"] = _default;